/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/ConnectionsList.Props" />
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface IConnectionsListProps extends IShowPanelProps {
    connections?: ExternalConnection[];
    onOpenRemoveConnectionDialog: (connection: ExternalConnection, onDialogClose: () => void) => void;
    hasWritePermission: boolean;
}
